// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-user-profile-edit][data-v-0ad6f2d2] {\n  max-width: 69rem;\n  margin: 3rem 0;\n}\n", ""]);
// Exports
module.exports = exports;
